import { useContext } from "react";

import { ServerDataContext } from "../contexts";

const useServerData = () => {
  return useContext(ServerDataContext);
};

export { useServerData };
